/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsFeedListResponse } from '../../models/news-feed-list-response';
import { NewsFeedPostRequest } from '../../models/news-feed-post-request';

export interface AddNewPostToNewsFeed$Params {
  
    /**
     * NewsFeed item to create
     */
    body: NewsFeedPostRequest
}

export function addNewPostToNewsFeed(http: HttpClient, rootUrl: string, params: AddNewPostToNewsFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
  const rb = new RequestBuilder(rootUrl, addNewPostToNewsFeed.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsFeedListResponse>;
    })
  );
}

addNewPostToNewsFeed.PATH = '/rest/newsfeed/post';
